// extracted by mini-css-extract-plugin
module.exports = {"Label":"styles_Label__j02Qw"};